module.exports = __webpack_public_path__ + "img/gcghealthcare.90cf4cdb.jpg";